import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA] text-[#0A0F1C]">
      <Header />
      <div className="pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center text-[#002FA7] hover:text-[#001D66] mb-8 text-xs font-bold uppercase tracking-widest transition-colors">
            <ArrowLeft className="w-4 h-4 mr-1.5" />
            Back to Home
          </Link>

          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-[#0A0F1C] mb-8">Privacy Policy</h1>

          <div className="prose prose-slate max-w-none text-[#475569] leading-relaxed">
            <p className="text-base">
              At <strong className="text-[#0A0F1C]">Trademark Logo Design</strong>, we are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This Privacy Policy outlines how we collect, use, and protect your personal data.
            </p>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Information We Collect</h2>
            <p>We collect personal information when you visit our website, submit a form, or communicate with us:</p>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li><strong>Personal Identification Information:</strong> Name, email address, phone number, and billing information.</li>
              <li><strong>Non-personal Information:</strong> IP address, browser type, operating system, and usage data.</li>
              <li><strong>Cookies and Tracking:</strong> We use cookies to enhance your experience, analyze traffic, and personalize content.</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li>To process and manage your trademark applications and service requests.</li>
              <li>To communicate with you about your orders and service updates.</li>
              <li>To respond to inquiries and provide customer support.</li>
              <li>To improve our website, products, and services.</li>
              <li>To send promotional materials if you have opted in.</li>
              <li>To prevent fraud and ensure site security.</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">How We Protect Your Information</h2>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li><strong>Encryption:</strong> SSL encryption protects sensitive data during transmission.</li>
              <li><strong>Secure Storage:</strong> Data is stored in secure environments with restricted access.</li>
              <li><strong>Regular Audits:</strong> We regularly review security practices to safeguard your data.</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Sharing Your Information</h2>
            <p>We do not sell your personal information. We may share data with:</p>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li><strong>Service Providers:</strong> Trusted partners who assist with operations, payments, or support.</li>
              <li><strong>Legal Compliance:</strong> When required by law or to protect our rights.</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Your Rights</h2>
            <ul className="list-disc pl-6 space-y-2 text-sm">
              <li><strong>Access & Correction:</strong> Request access to or corrections of your data.</li>
              <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications at any time.</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information.</li>
            </ul>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Changes to This Policy</h2>
            <p className="text-sm">
              We may update this Privacy Policy periodically. Changes will be posted on this page with an updated effective date.
            </p>

            <h2 className="text-2xl font-bold text-[#0A0F1C] mt-10 mb-4">Contact Us</h2>
            <div className="bg-[#FAFAFA] border border-[#E2E8F0] p-6 mt-4 text-sm">
              <p><strong>Company:</strong> Trademark Logo Design</p>
              <p><strong>Address:</strong> 9350 Wilshire Blvd Suite 203, Beverly Hills, CA 90212, United States</p>
              <p><strong>Phone:</strong> (800) 555-1234</p>
              <p><strong>Email:</strong> info@trademarklogodesign.com</p>
            </div>

            <p className="text-xs text-slate-400 mt-10 pt-6 border-t border-slate-200">
              <strong>Effective Date:</strong> December 30, 2024
            </p>
            <p className="text-sm mt-4">By using our website, you consent to the terms of this Privacy Policy.</p>
          </div>
        </div>
      </div>
      <Footer onOpenContactForm={() => {}} />
    </div>
  );
};

export default PrivacyPolicy;
